exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".template-main-container .email-template-header {\n  padding: 2.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n\n.template-main-container .action-buttons {\n  display: flex;\n  gap: 1rem; }\n  .template-main-container .action-buttons .icon {\n    cursor: pointer; }\n    .template-main-container .action-buttons .icon svg {\n      height: 1.5rem;\n      width: 1.5rem; }\n", ""]);

// exports
